
import { useEffect } from "react"
import { useInRouterContext, useLocation } from "react-router-dom"
import { useToast } from "../../hooks/useToast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "../../components/ui/toast"

// Sub-component so the useLocation call only runs when this <Toaster /> is
// rendered inside a <Router>. The Toaster is mounted both inside the
// Router (routes/index.tsx) and outside one (App.js); calling useLocation
// outside the router would crash, so we only mount this listener
// conditionally below.
function DismissOnNavigate() {
  const { dismiss } = useToast()
  const location = useLocation()

  // Dismiss every active toast whenever the user navigates to a new
  // page. The existing auto-timeout and close-button paths still apply
  // on the same page — this just adds "leaving the page closes them".
  useEffect(() => {
    dismiss()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return null
}

export function Toaster() {
  const { toasts } = useToast()
  const inRouter = useInRouterContext()

  return (
    <ToastProvider>
      {inRouter && <DismissOnNavigate />}
      {toasts.map(function ({ id, title, description, action, ...props }) {
        if (title && title.toLowerCase() === 'error') {
          console.error("Toast Error", { title, description });
        }
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1 select-text">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}

